const SIEMPRE_CON_MILES = { useGrouping: 'always' } as unknown as Intl.NumberFormatOptions;

// Importes del presupuesto en pantalla: siempre con céntimos (dos decimales), como se guardan.
// Antes se pintaban sin decimales y una línea de 1,01 € se veía como "1".
export function fmtImporte(n: number): string {
  return (Number(n) || 0).toLocaleString('es-ES', { ...SIEMPRE_CON_MILES, minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Cantidades (unidades, jornadas): sin ceros de relleno, pero sin perder decimales.
export function fmtCantidad(n: number): string {
  return (Number(n) || 0).toLocaleString('es-ES', { ...SIEMPRE_CON_MILES, minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

// Precio por unidad: con céntimos, y sin cortar si el precio lleva más decimales (0,335 €).
export function fmtPrecio(n: number): string {
  return (Number(n) || 0).toLocaleString('es-ES', { ...SIEMPRE_CON_MILES, minimumFractionDigits: 2, maximumFractionDigits: 4 });
}

export function parseImporte(text: string): number {
  const limpio = String(text ?? '').replace(/[€\s]/g, '');
  const normal = limpio.includes(',')
    ? limpio.replace(/\./g, '').replace(',', '.')
    : limpio.replace(/\.(?=\d{3}(?:\.|$))/g, '');
  const n = parseFloat(normal);
  return Number.isFinite(n) ? n : 0;
}

export function numeroParaEditar(n: unknown): string {
  if (n === null || n === undefined || n === '') return '';
  const v = Number(n);
  return Number.isFinite(v) ? String(v).replace('.', ',') : String(n);
}
